import { 
    GET_REVIEW_APPROVAL_FAIL, 
    GET_REVIEW_APPROVAL_SUCCESS, 
    GET_REVIEW_DETAILS_FAIL, 
    GET_REVIEW_DETAILS_SUCCESS, 
    GET_REVIEW_EXPORT_FAIL, 
    GET_REVIEW_EXPORT_SUCCESS, 
    GET_REVIEW_LISTING_FAIL, 
    GET_REVIEW_LISTING_SUCCESS, 
    RESET_REVIEW_DOCUMENT_STATE, 
    RESET_REVIEW_STATE 
} from "./actionTypes"

const INIT_STATE = {
    reviewListing: [],
    reviewDetails: [],
    reviewApproval: [],
    exportReview: [],
    error: [],
}

const Review = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_REVIEW_LISTING_SUCCESS:
            return {
                ...state,
                reviewListing: action.payload
            }
        case GET_REVIEW_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            }
        case GET_REVIEW_DETAILS_SUCCESS:
            return {
                ...state,
                reviewDetails: action.payload
            }
        case GET_REVIEW_DETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
            }
        case GET_REVIEW_APPROVAL_SUCCESS:
            return {
                ...state,
                reviewApproval: action.payload
            }
        case GET_REVIEW_APPROVAL_FAIL:
            return {
                ...state,
                error: action.payload,
            }
        case GET_REVIEW_EXPORT_SUCCESS:
            return {
                ...state,
                exportReview: action.payload
            }
        case GET_REVIEW_EXPORT_FAIL:
            return {
                ...state,
                error: action.payload,
            }
        case RESET_REVIEW_STATE:
            return {
                ...state,
                reviewListing: [],
                reviewDetails: [],
                reviewApproval: [],
                exportReview: [],
                error: [],
            }
        case RESET_REVIEW_DOCUMENT_STATE:
            return {
                ...state,
                exportReview: [],
                error: [],
            }
        default:
            return state
    }
}

export default Review
